let DateInput = function(options) {
  this.container = options.container;
  this.input = options.input;
  this.toggleButton = options.toggleButton;
  this.nextButtonHTML = options.nextButtonHTML;
  this.previousButtonHTML = options.previousButtonHTML;

  this.container.classList.add('date-input--enhanced')
  this.monthDate = this.hasSelectedDate() ? this.getInputDate() : new Date();
  this.selectedDate = this.hasSelectedDate() ? this.getInputDate() : null;
  this.setupOptions(options);
  this.setupKeys();
  this.setupMonthNames();
  this.setupShortMonthNames();
  this.setupToggleButton();
  this.setupCalendarHtml();
  this.setupClickOutside();
  this.updateSelectedDateStatusBox();
};

DateInput.prototype.pad = function(n) {
  return n < 10 ? '0' + n : '' + n;
};

DateInput.prototype.hasSelectedDate = function() {
  return /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(this.input.value);
};

DateInput.prototype.getInputDate = function() {
  let parts = this.input.value.split('/');
  return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
};

DateInput.prototype.updateInputValues = function(date) {
  this.input.value = this.pad(date.getDate()) + '/' + this.pad(date.getMonth() + 1) + '/' + date.getFullYear();
};

DateInput.prototype.setupCalendarHtml = function() {
  this.calendar = document.createElement('div');
  let positionClass = this.options.position === 'above' ? 'datepicker--above' : 'datepicker--below';
  this.calendar.className = 'datepicker hidden absolute ' + positionClass;
  this.calendar.setAttribute('aria-label', 'date picker');
  this.calendar.setAttribute('role', 'group');
  this.calendar.setAttribute('tabindex', '-1');
  this.calendar.innerHTML = this.getCalendarHtml(this.monthDate.getFullYear(), this.monthDate.getMonth());
  this.addEventListeners();
  this.container.appendChild(this.calendar);
};

DateInput.prototype.updateSelectedDateStatusBox = function() {
  let status = this.selectedDate ? 'The currently selected date is ' + this.getFullDateString(this.selectedDate) : '';
  let statusBox = this.container.querySelector('.datepicker-selected-date');
  if (statusBox) {
    statusBox.innerHTML = status;
  }
};

DateInput.prototype.getFullDateString = function(d) {
  return d.getDate() + ' ' + this.monthNames[d.getMonth()] + ' ' + d.getFullYear();
};

DateInput.prototype.getSelectedDateElementId = function() {
  return this.input.id + '-selected-date';
};

DateInput.prototype.getCalendarHtml = function(year, month) {
  let html = '<div id="' + this.getSelectedDateElementId() + '" class="datepicker-selected-date sr-only"></div>';
  html += '<div class="datepicker-actions">';
  html += '<button class="datepicker-previousMonthButton" type="button" aria-label="previous month">' + this.previousButtonHTML + '</button>';
  html += '<select>';
  html += this.getSelectOptionsHtml(year, month);
  html += '</select>';
  html += '<button class="datepicker-nextMonthButton" type="button" aria-label="next month">' + this.nextButtonHTML + '</button>';
  html += '</div>';
  html += '<div role="status" aria-live="polite" class="sr-only">';
  html += this.monthNames[month] + " " + year;
  html += '</div>';
  html += '<table role="grid">';
  html += '<thead>';
  html += '<tr>';
  html += '<th><span aria-hidden="true">M</span><span class="sr-only">Monday</span></th>';
  html += '<th><span aria-hidden="true">T</span><span class="sr-only">Tuesday</span></th>';
  html += '<th><span aria-hidden="true">W</span><span class="sr-only">Wednesday</span></th>';
  html += '<th><span aria-hidden="true">T</span><span class="sr-only">Thursday</span></th>';
  html += '<th><span aria-hidden="true">F</span><span class="sr-only">Friday</span></th>';
  html += '<th><span aria-hidden="true">S</span><span class="sr-only">Saturday</span></th>';
  html += '<th><span aria-hidden="true">S</span><span class="sr-only">Sunday</span></th>';
  html += '</tr>';
  html += '</thead>';
  html += '<tbody>';
  html += this.getCalendarTableRows(month, year);
  html += '</tbody>';
  html += '</table>';
  return html;
};

DateInput.prototype.getSelectOptionsHtml = function(year, month) {
  let html = '';
  let d = new Date(year, month, 1);
  d.setMonth(d.getMonth() - 24);
  for (let i = -1; i < 48; i++) {
    d.setMonth(d.getMonth() + 1);
    let selected = d.getMonth() == month && d.getFullYear() == year ? 'selected' : '';
    html += '<option value="' + d.toString() + '" ' + selected + '>';
    html += this.shortMonthNames[d.getMonth()] + ' ' + d.getFullYear();
    html += '</option>';
  }
  return html;
};

DateInput.prototype.onSelectChange = function(e) {
  this.monthDate = new Date(e.target.value);
  this.updateCalendarHtml(this.monthDate.getFullYear(), this.monthDate.getMonth());
};

DateInput.prototype.setupMonthNames = function() {
  this.monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
};

DateInput.prototype.setupShortMonthNames = function() {
  this.shortMonthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
};

DateInput.prototype.setupOptions = function(options) {
  let defaults = {};
  defaults.currentDate = (function() {
    let d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }());
  this.options = Object.assign({}, defaults, options);
};

DateInput.prototype.getCalendarTableRows = function(month, year) {
  let html = '';
  let now = new Date();
  now.setHours(0, 0, 0, 0);

  let first_day = new Date(year, month, 1),
      first_day_weekday = first_day.getDay() == 0 ? 7 : first_day.getDay();

  let month_length = new Date(year, month + 1, 0).getDate(),
      previous_month_length = new Date(year, month, 0).getDate();

  let day = 1,
      prev = 1,
      next = 1;

  html += '<tr class="week">';
  for (let i = 0; i < 9; i++) {
    for (let j = 1; j <= 7; j++) {
      if (day <= month_length && (i > 0 || j >= first_day_weekday)) {
        let d = new Date(year, month, day);

        let focusableDate = null;
        if (this.selectedDate && this.selectedDate.getMonth() === d.getMonth() && this.selectedDate.getFullYear() === d.getFullYear()) {
          focusableDate = this.selectedDate;
        } else if (now.getMonth() === d.getMonth() && now.getFullYear() === d.getFullYear()) {
          focusableDate = now;
        } else {
          focusableDate = first_day;
        }

        html += this.getCellHtml(d, {
          today: d.getTime() === now.getTime(),
          focusable: focusableDate.getTime() === d.getTime(),
          selected: this.selectedDate && this.selectedDate.getTime() === d.getTime()
        });
        day++;
      } else {
        if (day <= month_length) {
          html += '<td class="day other-month">';
          html += new Date(year, month - 1, previous_month_length - first_day_weekday + prev + 1).getDate();
          html += '</td>';
          prev++;
        } else {
          html += '<td class="day other-month">';
          html += new Date(year, month + 1, next).getDate();
          html += '</td>';
          next++;
        }
      }
    }

    if (day > month_length) {
      html += '</tr>';
      break;
    } else {
      html += '</tr><tr class="week">';
    }
  }
  return html;
};

DateInput.prototype.getCellHtml = function(date, options) {
  let label = date.getDate() + ' ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear();

  let tdClass = '';
  if (options.today) {
    tdClass += ' datepicker-day-isToday';
  }
  if (options.focusable) {
    tdClass += ' datepicker-day-isFocused';
  }

  let html = '<td';
  html += options.focusable ? ' tabindex="0" ' : ' tabindex="-1" ';
  html += options.selected ? ' aria-selected="true" ' : ' aria-selected="false" ';
  html += ' role="gridcell" ';
  html += ' data-date="' + date.toString() + '" ';
  html += ' class="' + tdClass + '" ';
  html += '>';

  if (options.today) {
    html += '<span class="datepicker-today">Today</span>';
  }

  html += '<span class="datepicker-day" aria-hidden="true">';
  html += date.getDate();
  html += '</span>';
  html += '<span class="sr-only">' + label + '</span>';
  html += '</td>';

  return html;
};

DateInput.prototype.addEventListeners = function() {
  this.calendar.addEventListener('click', (event) => {
    if (event.target.closest('button:first-child')) {
      this.onPreviousClick(event);
    }
  });

  this.calendar.addEventListener('click', (event) => {
    if (event.target.closest('button:last-child')) {
      this.onNextClick(event);
    }
  });

  this.calendar.addEventListener('click', (event) => {
    if (event.target.closest('[role=gridcell]')) {
      this.onCellClick(event);
    }
  });

  this.calendar.addEventListener('keydown', (event) => {
    if (event.target.closest('[role=gridcell]')) {
      this.onCellKeyDown(event);
    }
  });

  this.calendar.addEventListener('change', (event) => {
    if (event.target.closest('select')) {
      this.onSelectChange(event);
    }
  });

  this.calendar.addEventListener('keydown', (event) => {
    this.onCalendarKeyDown(event);
  });
};

DateInput.prototype.setupToggleButton = function() {
  this.toggleButton.setAttribute('aria-haspopup', 'true');
  this.toggleButton.setAttribute('aria-describedby', this.getSelectedDateElementId());
  this.toggleButton.addEventListener('click', this.onToggleButtonClick.bind(this));
};

DateInput.prototype.setupClickOutside = function() {
  this.onDocumentClick = (e) => {
    if (!this.container.contains(e.target)) {
      this.hide();
    }
  };
  document.addEventListener('click', this.onDocumentClick);
};

DateInput.prototype.onToggleButtonClick = function(e) {
  e.preventDefault();

  if (this.toggleButton.getAttribute('aria-expanded') === 'true') {
    this.hide();
  } else {
    if (this.hasSelectedDate()) {
      this.selectedDate = this.getInputDate();
      this.updateCalendarHtml(this.selectedDate.getFullYear(), this.selectedDate.getMonth());
    } else {
      this.updateCalendarHtml(this.monthDate.getFullYear(), this.monthDate.getMonth());
    }
    this.show();
    this.calendar.focus();
  }
};

DateInput.prototype.hide = function() {
  this.calendar.classList.add('hidden');
  this.toggleButton.setAttribute('aria-expanded', 'false');
  this.toggleButton.classList.remove('bg-neutral-200', 'hover:bg-neutral-300');
  this.toggleButton.classList.add('bg-neutral-100', 'hover:bg-neutral-200');
};

DateInput.prototype.show = function() {
  this.calendar.classList.remove('hidden');
  this.toggleButton.setAttribute('aria-expanded', 'true');
  this.toggleButton.classList.remove('bg-neutral-100', 'hover:bg-neutral-200');
  this.toggleButton.classList.add('bg-neutral-200', 'hover:bg-neutral-300');
};

DateInput.prototype.setupKeys = function() {
  this.keys = {
    tab: 9, enter: 13, esc: 27, space: 32,
    pageup: 33, pagedown: 34, end: 35, home: 36,
    left: 37, up: 38, right: 39, down: 40
  };
};

DateInput.prototype.onCalendarKeyDown = function(e) {
  switch (e.keyCode) {
    case this.keys.esc:
      this.hide();
      this.toggleButton.focus();
      break;
  }
};

DateInput.prototype.onCellKeyDown = function(e) {
  switch (e.keyCode) {
    case this.keys.down:
      this.onDayDownPressed(e);
      break;
    case this.keys.up:
      this.onDayUpPressed(e);
      break;
    case this.keys.left:
      this.onDayLeftPressed(e);
      break;
    case this.keys.right:
      this.onDayRightPressed(e);
      break;
    case this.keys.space:
    case this.keys.enter:
      this.onDaySpacePressed(e);
      break;
    case this.keys.tab:
      this.onDayTabPressed(e);
      break;
  }
};

DateInput.prototype.onCellClick = function(e) {
  const dateCell = e.target.closest('[role=gridcell]');
  let d = new Date(dateCell.getAttribute('data-date'));

  this.updateInputValues(d);
  this.selectedDate = d;
  this.selectDate(d);
  this.hide();
  this.updateSelectedDateStatusBox();
  this.toggleButton.focus();
};

DateInput.prototype.onPreviousClick = function(e) {
  this.showPreviousMonth();
};

DateInput.prototype.onNextClick = function(e) {
  this.showNextMonth();
};

DateInput.prototype.onDaySpacePressed = function(e) {
  e.preventDefault();
  const dateCell = e.target.closest('[role=gridcell]');
  let d = new Date(dateCell.getAttribute('data-date'));
  this.updateInputValues(d);
  this.selectedDate = d;
  this.selectDate(d);
  this.hide();
  this.updateSelectedDateStatusBox();
  this.toggleButton.focus();
};

DateInput.prototype.onDayTabPressed = function(e) {
  e.preventDefault();
  if (e.shiftKey) {
    const nextMonthButton = this.container.querySelector('.datepicker-nextMonthButton');
    if (nextMonthButton) nextMonthButton.focus();
  } else {
    const previousMonthButton = this.container.querySelector('.datepicker-previousMonthButton');
    if (previousMonthButton) previousMonthButton.focus();
  }
};

DateInput.prototype.selectDate = function(date) {
  const selectedCells = this.calendar.querySelectorAll('[aria-selected="true"]');
  selectedCells.forEach(cell => {
    cell.setAttribute('aria-selected', 'false');
  });

  const newSelectedCell = this.getDayCell(date);
  if (newSelectedCell) {
    newSelectedCell.setAttribute('aria-selected', 'true');
  }
};

DateInput.prototype.unhighlightCell = function(date) {
  let cell = this.getDayCell(date);
  cell.setAttribute('tabindex', '-1');
};

DateInput.prototype.highlightCell = function(date) {
  this.unhighlightCell(this.getFocusedCellDate());
  let cell = this.getDayCell(date);
  cell.setAttribute('tabindex', '0');
  cell.focus();
};

DateInput.prototype.getFocusedCell = function() {
  return this.calendar.querySelector('[tabindex="0"]');
};

DateInput.prototype.getFocusedCellDate = function() {
  const focusedCell = this.getFocusedCell();
  return new Date(focusedCell.getAttribute('data-date'));
};

DateInput.prototype.onDayDownPressed = function(e) {
  e.preventDefault();
  let date = this.getFocusedCellDate();
  let newDate = this.getSameDayNextWeek(date);
  if (newDate.getMonth() == date.getMonth()) {
    this.highlightCell(newDate);
  } else {
    this.monthDate = newDate;
    this.updateCalendarHtml(newDate.getFullYear(), newDate.getMonth());
    this.highlightCell(newDate);
  }
};

DateInput.prototype.onDayUpPressed = function(e) {
  e.preventDefault();
  let date = this.getFocusedCellDate();
  let newDate = this.getSameDayLastWeek(date);
  if (newDate.getMonth() == this.monthDate.getMonth()) {
    this.highlightCell(newDate);
  } else {
    this.monthDate = newDate;
    this.updateCalendarHtml(newDate.getFullYear(), newDate.getMonth());
    this.highlightCell(newDate);
  }
};

DateInput.prototype.onDayLeftPressed = function(e) {
  e.preventDefault();
  let date = this.getFocusedCellDate();
  let newDate = this.getPreviousDay(date);
  if (newDate.getMonth() == this.monthDate.getMonth()) {
    this.highlightCell(newDate);
  } else {
    this.monthDate = newDate;
    this.updateCalendarHtml(newDate.getFullYear(), newDate.getMonth());
    this.highlightCell(newDate);
  }
};

DateInput.prototype.onDayRightPressed = function(e) {
  e.preventDefault();
  let date = this.getFocusedCellDate();
  let newDate = this.getNextDay(date);
  if (newDate.getMonth() == this.monthDate.getMonth()) {
    this.highlightCell(newDate);
  } else {
    this.monthDate = newDate;
    this.updateCalendarHtml(newDate.getFullYear(), newDate.getMonth());
    this.highlightCell(newDate);
  }
};

DateInput.prototype.getPreviousDay = function(date) {
  let d = new Date(date);
  d.setDate(d.getDate() - 1);
  return d;
};

DateInput.prototype.getSameDayLastWeek = function(date) {
  let d = new Date(date);
  d.setDate(d.getDate() - 7);
  return d;
};

DateInput.prototype.getNextDay = function(date) {
  let d = new Date(date);
  d.setDate(d.getDate() + 1);
  return d;
};

DateInput.prototype.getSameDayNextWeek = function(date) {
  let d = new Date(date);
  d.setDate(d.getDate() + 7);
  return d;
};

DateInput.prototype.getDayCell = function(date) {
  return this.calendar.querySelector('[data-date="' + date.toString() + '"]');
};

DateInput.prototype.updateCalendarHtml = function(year, month) {
  let statusElement = this.calendar.querySelector('[role=status]');
  if (statusElement) {
    statusElement.innerHTML = this.monthNames[month] + ' ' + year;
  }

  let selectElement = this.calendar.querySelector('select');
  if (selectElement) {
    selectElement.innerHTML = this.getSelectOptionsHtml(year, month);
  }

  let tbodyElement = this.calendar.querySelector("tbody");
  if (tbodyElement) {
    tbodyElement.innerHTML = this.getCalendarTableRows(month, year);
  }
};

DateInput.prototype.showPreviousMonth = function() {
  let pm = this.getPreviousMonth();
  this.monthDate = pm;
  this.updateCalendarHtml(pm.getFullYear(), pm.getMonth());
};

DateInput.prototype.showNextMonth = function() {
  let nm = this.getNextMonth();
  this.monthDate = nm;
  this.updateCalendarHtml(nm.getFullYear(), nm.getMonth());
};

DateInput.prototype.getPreviousMonth = function() {
  let d = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth(), 1);
  d.setDate(0);
  d.setDate(1);
  return d;
};

DateInput.prototype.getNextMonth = function() {
  let d = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth());
  d.setMonth(d.getMonth() + 1);
  d.setDate(1);
  return d;
};

export default DateInput;
